/* HALDEN - Performance: carrega a ficha do quick-add (impact sheet) sob demanda.
   Os modais <quick-add-modal data-lazy-sheet-url> nascem vazios. Ao passar o mouse,
   tocar ou clicar no botao, buscamos sections/halden-quick-add-sheet.liquid pela
   Section Rendering API (/products/<handle>?section_id=halden-quick-add-sheet) e
   injetamos o <impact-quick-add-sheet>. A partir dai o modal se comporta como antes. */
(() => {
  const SHEET_TOKEN = 'halden-lazy';

  const fetchSheetHtml = (modal) => {
    if (!modal.__haldenSheetPromise) {
      modal.__haldenSheetPromise = fetch(modal.dataset.lazySheetUrl, { headers: { Accept: 'text/html' } })
        .then((response) => {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .catch((error) => {
          modal.__haldenSheetPromise = null;
          throw error;
        });
    }
    return modal.__haldenSheetPromise;
  };

  const buildSheet = (modal, html) => {
    const uid = (modal.dataset.lazySheetId || modal.id || '').replace(/[^a-zA-Z0-9_-]/g, '');
    const scoped = html.split(SHEET_TOKEN).join(SHEET_TOKEN + '-' + uid);
    const doc = new DOMParser().parseFromString(scoped, 'text/html');
    const sheet = doc.querySelector('impact-quick-add-sheet');
    if (!sheet) return null;

    if (modal.dataset.lazyPriceOrder === 'current_first') {
      const prices = sheet.querySelector('.halden-impact-quick-add__prices');
      const price = prices && prices.querySelector('.halden-impact-quick-add__price');
      if (prices && price) {
        prices.insertBefore(price, prices.firstChild);
        prices.dataset.priceDisplayOrder = 'current_first';
      }
    }

    return document.importNode(sheet, true);
  };

  const patch = () => {
    const QuickAddModal = customElements.get('quick-add-modal');
    if (!QuickAddModal || QuickAddModal.prototype.__haldenLazyPatched) return;
    QuickAddModal.prototype.__haldenLazyPatched = true;
    const originalShow = QuickAddModal.prototype.show;

    QuickAddModal.prototype.show = function (opener) {
      const lazyUrl = this.dataset.lazySheetUrl;
      const content = this.modalContent || this.querySelector('[id^="QuickAddInfo-"]');
      if (!lazyUrl || !content || content.querySelector('impact-quick-add-sheet')) {
        return originalShow.call(this, opener);
      }
      if (this.__haldenOpening) return;
      this.__haldenOpening = true;

      const spinner = opener ? opener.querySelector('.loading__spinner') : null;
      if (opener) {
        opener.setAttribute('aria-disabled', 'true');
        opener.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      fetchSheetHtml(this)
        .then((html) => {
          const sheet = buildSheet(this, html);
          if (!sheet) throw new Error('quick-add sheet not found');
          content.innerHTML = '';
          content.appendChild(sheet);
          originalShow.call(this, opener);
        })
        .catch(() => {
          // Fallback: abre a pagina do produto em vez de deixar o cliente sem resposta.
          window.location.href = lazyUrl.split('?')[0];
        })
        .finally(() => {
          this.__haldenOpening = false;
          if (opener) {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
          }
          if (spinner) spinner.classList.add('hidden');
        });
    };
  };

  // Aquece a ficha assim que o cliente demonstra intencao no botao (hover, toque ou foco).
  const warmUp = (event) => {
    const target = event.target;
    const opener = target && target.closest ? target.closest('modal-opener[data-modal]') : null;
    if (!opener) return;
    let modal = null;
    try {
      modal = document.querySelector(opener.dataset.modal);
    } catch (error) {
      modal = null;
    }
    if (modal && modal.dataset.lazySheetUrl && !modal.querySelector('impact-quick-add-sheet')) {
      fetchSheetHtml(modal).catch(() => {});
    }
  };
  ['pointerenter', 'touchstart', 'focusin'].forEach((type) => {
    document.addEventListener(type, warmUp, { capture: true, passive: true });
  });

  if (customElements.get('quick-add-modal')) patch();
  else customElements.whenDefined('quick-add-modal').then(patch);
})();
